import React from 'react';
import { Box, Typography, Button, Container } from '@mui/joy';
import { useNavigate } from 'react-router-dom';

const PostJobPromotion: React.FC = () => {
  const navigate = useNavigate();
  
  const handlePostJob = () => {
    navigate('/hiring/post-job-workflow');
  };

  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '200px',
        maxHeight: '33vh',
        bgcolor: 'linear-gradient(135deg, #2E2D7E 0%, #4A4A9E 100%)',
        background: 'linear-gradient(135deg, #2E2D7E 0%, #4A4A9E 100%)',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        py: { xs: 3, md: 4 },
        position: 'relative',
        overflow: 'hidden',
        '&::before': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'radial-gradient(circle at 70% 30%, rgba(255,255,255,0.1) 0%, transparent 50%)',
          pointerEvents: 'none',
        }
      }}
    >
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            flexDirection: { xs: 'column', md: 'row' },
            gap: { xs: 3, md: 4 },
            textAlign: { xs: 'center', md: 'left' }
          }}
        >
          {/* Content Section */}
          <Box sx={{ flex: 1, maxWidth: { xs: '100%', md: '60%' } }}>
            <Typography
              level="h1"
              sx={{
                fontSize: { xs: '2rem', md: '2.5rem', lg: '3rem' },
                fontWeight: 700,
                mb: 2,
                lineHeight: 1.2,
                color: 'white',
                textShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}
            >
              FIND YOUR NEXT HIRE
            </Typography>
            
            <Typography
              level="body-lg"
              sx={{
                fontSize: { xs: '1rem', md: '1.125rem' },
                mb: 3,
                color: 'rgba(255, 255, 255, 0.9)',
                lineHeight: 1.5,
                maxWidth: '500px',
                mx: { xs: 'auto', md: 0 }
              }}
            >
              Post your job and find the perfect people through video-first hiring.
            </Typography>

            <Button
              size="lg"
              onClick={handlePostJob}
              sx={{
                bgcolor: 'white',
                color: '#2E2D7E',
                px: 4,
                py: 1.5,
                fontSize: '1.125rem',
                fontWeight: 600,
                borderRadius: '12px',
                boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                '&:hover': {
                  bgcolor: '#f8f9fa',
                  color: '#2E2D7E',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 24px rgba(0,0,0,0.2)',
                },
                transition: 'all 0.3s ease'
              }}
            >
              Post a New Job
            </Button>
          </Box>

          
        </Box>
      </Container>
    </Box>
  );
};

export default PostJobPromotion;
